import { useEffect, useMemo, useState } from "react";
import { getLocale, useSelector, shallowEqual } from "umi";
import moment from 'moment';
import { KEY_DAYS_DEFAULT_VALUE, LANGUAGE_MAP, PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';

import { getApiData } from "@/pages/dashboard/services/common";
import { formatFilterValues, formatAccumulation } from "@/pages/dashboard/utils/utils";
import { getMultiSortParams } from "@/pages/dashboard/components/OverallTableCo/utils";
import { useOverLimitTrigger } from "@/pages/dashboard/components/OverLimitTip";
import { flattenCustomDimensions } from "./_utils";
import { stringToFunction } from "@/pages/dashboard/utils/stringToJson";
import { IConfigData } from "@/pages/dashboard/components/PageContainer/type";
import { dynamicString } from "@home/utils/dynamicString";
// import {testData} from './testData';
export const useData = (
  config: any,
  filterVal: any,
  filterLoading: boolean,
  accumulated: string[],
  extraParams?: Record<string, any>,
) => {
  const {
    api,
    beforeRequest,
    formatData,
  } = config;
  const { tableApi } = api || {};
  const gameCode = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.game_code;
  }, shallowEqual);
  const [componentData, setComponentData] = useState({
    average: null,
    metrics_list: [],
    page: 1,
    page_size: 10,
    row_count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { overLimitBarTriggerKey, handleResponse } = useOverLimitTrigger();

  // 点击筛选器的时候
  useEffect(() => {
    if (!filterVal) return;
    !filterLoading && getLtvTrackingFunc(KEY_DAYS_DEFAULT_VALUE, { pageIndex: 1, pageSize: 10 }, []);
  }, [filterVal, extraParams]);

  const getLtvTrackingFunc = (
    keyDays: number,
    paging: any,
    sort: any[],
    accumulatedOverride?: string[],
  ) => {
    // const { timeType, filterValue } = formValue
    const { rangeTime, timeType, diff, ...filters } = filterVal || {};
    const by = sort?.[0]?.code || 'date';
    const order = sort?.[0]?.order;
    const accumulation = formatAccumulation(accumulatedOverride ?? accumulated);

    let params = {
      game_code: gameCode,
      filters: formatFilterValues(filters),
      start_time: moment(rangeTime?.[0]).format('YYYY-MM-DD'),
      end_time: moment(rangeTime?.[1]).format('YYYY-MM-DD'),
      period: PERIODTIMEOBJ?.[timeType] || 'daily',
      key_days: keyDays,
      accumulation,
      desc: order ? order === 'desc' : true,
      sorted_by: by,
      page: paging?.pageIndex,
      page_size: paging?.pageSize,
      multi_sort: getMultiSortParams([], [], {by, order}, 'dod', true),
    };

    if (typeof beforeRequest === 'string') {
      params = stringToFunction?.(beforeRequest)?.(params);
    }
    if (typeof beforeRequest === 'function') {
      params = beforeRequest(params);
    }
    params = { ...params, ...(extraParams || {}) };
    setLoading(true);
    const locale = LANGUAGE_MAP[getLocale()];

    getApiData(`${tableApi}?language=${locale}`, params).then((dataList: any) => {
      let result = dataList;
      result = flattenCustomDimensions(dataList);
      if (formatData) {
        if (typeof formatData === 'string') {
          result = stringToFunction(formatData)(result, filterVal);
        }
        if (typeof formatData === 'function') {
          result = formatData(result, filterVal);
        }
      }
      const { custom_dimensions, ...resultList } = result; // eslint-disable-line camelcase
      setError(false);
      // testTableData
      setComponentData(resultList);
      handleResponse(dataList?.front_logical_flag);
      setLoading(false);
    }).catch((e) => {
      console.error(e);
      setError(true);
      setLoading(false);
    });
  };

  return {
    getLtvTrackingFunc,
    // nodata 不在此封装，因为可能是接口的个别项目nodata
    componentData,
    loading,
    error,
    overLimitBarTriggerKey,
  };
};

export const useLtvTrackingCoMemo = ({
  data,
  propsComponentMetrics,
}: {
  data: IConfigData;
  propsComponentMetrics: any[];
}) => {
  const componentMetrics = useMemo(() => {
    return propsComponentMetrics.map((metric: any) => {
      return {
        ...metric,
        enName: dynamicString(metric.enName, data) || '',
        cnName: dynamicString(metric.cnName, data) || '',
      };
    });
  }, []);

  return {
    componentMetrics,
  };
};
